import(/* webpackMode: "eager", webpackExports: ["ChallengeMode"] */ "/vercel/path0/src/components/shared/ChallengeMode.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroSection"] */ "/vercel/path0/src/components/shared/HeroSection.tsx");
